
export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12 pb-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">会社情報</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="#company" className="hover:text-white transition-colors cursor-pointer">
                  会社概要
                </a>
              </li>
              <li>
                <a href="#area" className="hover:text-white transition-colors cursor-pointer">
                  対応エリア
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white transition-colors cursor-pointer">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">サービス</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  遺品整理
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  生前整理
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  不用品回収
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  特殊清掃
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  ゴミ屋敷片付け
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">お問い合わせ</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center gap-2">
                <i className="ri-phone-fill w-5 h-5 flex items-center justify-center"></i>
                <a href="tel:0120-000-000" className="hover:text-white transition-colors cursor-pointer">
                  0120-000-000
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-fill w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:info@example.com" className="hover:text-white transition-colors cursor-pointer">
                  info@example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-fill w-5 h-5 flex items-center justify-center"></i>
                <span>8:00〜20:00（年中無休）</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">SNS</h3>
            <div className="flex gap-4">
              <a 
                href="https://line.me/ti/p/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a 
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-400 hover:bg-blue-500 w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a 
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; 2024 遺品整理のハセガワ All Rights Reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                プライバシーポリシー
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                利用規約
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
